import React from 'react';
import { fetchPriceFromSANA, } from '../../stores/wizard';
import { wizardStore } from '../../stores/wizard';
import { useSnapshot } from "valtio";

const NavBar: React.FC = () => {
  const wizSnap = useSnapshot(wizardStore);

  console.log(wizSnap.activePrice.price);

  const addToCart = () => { }
  const getPrice = () => { 
    fetchPriceFromSANA(); 
  }

  return (
    <nav className="bg-gray-800 p-4 absolute top-0 inset-x-0">
      <div className="flex justify-between items-center">
        <div className="text-white text-lg font-semibold">Emblem Wizard</div>
        <div className="space-x-4">
          <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-300"
            onClick={getPrice}>
            Get Price
          </button>
          <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-300"
            onClick={addToCart}>
            Add to Cart
          </button>
        </div>
        <div className="text-white">
          Price $: {wizSnap.activePrice.price} 
          Discount %: {wizSnap.activePrice.discountPercent}
        </div>
        </div>
    </nav>
  );
}

export default NavBar;
